import { render, staticRenderFns } from "./tai-xiu-full-video.vue?vue&type=template&id=10233a03&scoped=true"
import script from "./tai-xiu-full-video.vue?vue&type=script&lang=js"
export * from "./tai-xiu-full-video.vue?vue&type=script&lang=js"
import style0 from "./tai-xiu-full-video.vue?vue&type=style&index=0&id=10233a03&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10233a03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10233a03')) {
      api.createRecord('10233a03', component.options)
    } else {
      api.reload('10233a03', component.options)
    }
    module.hot.accept("./tai-xiu-full-video.vue?vue&type=template&id=10233a03&scoped=true", function () {
      api.rerender('10233a03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/tai-xiu-full-video.vue"
export default component.exports